import { useEnterprisePermittedProducts } from 'bundles/unified-common/contexts/EnterprisePermittedProductsContext';
import { useIsWildcard } from 'bundles/unified-common/contexts/EnterpriseProgramContext';

const useIsLimitedContent = () => {
  const isWildcard = useIsWildcard(); // program level full catalog
  const enterprisePermittedProducts = useEnterprisePermittedProducts(); // org level limitation

  return enterprisePermittedProducts?.isProgramLimitedContent || !isWildcard;
};

export default useIsLimitedContent;
